import React, { useEffect, useState } from 'react'
import Online from "../../assets/icons/voyages/Online.svg"
import Clipboard from "../../assets/icons/voyages/clipboard-import.svg"
import Invoice from "../../assets/icons/voyages/Invoice.svg"
import ClipboardText from "../../assets/icons/voyages/clipboard-text.svg"
import ClipboardExport from "../../assets/icons/voyages/clipboard-export.svg"
import ClipboardDelete from "../../assets/icons/voyages/clipboard-delete.svg"
import format from 'date-fns/format'
import { DatePicker, Tag } from 'antd'
import Report from "../../assets/icons/voyages/Report.svg"
import Stats from '../../components/Statistics'
import { fetchInvoice, fetchStatementDocument, fetchVoyageEuaOverview,fetchPrefilledOrderDetails, fetchHistoryOrderDetails } from '../../features/Voyage/VoyageSlice'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import EmissionTemplate from "../../assets/files/Emission.pdf"
import ReportPdf from '../pdfcontainer/ReportPdf'
import DownloadDocument from '../Invoice/DownloadDocument'
import DeleteDocument from '../Invoice/DeleteDocument'
import OrderModal from '../Invoice/OrderModal'
import { getEuaOutstanding } from '../../features/EUA/EuaSlice'
const { RangePicker } = DatePicker

const FeumOverview = () => {

    const dispatch = useDispatch()
    const [data, setData] = useState([])
    const [spotPrice, setSpotPrice] = useState("")
    const selectedVessel = useSelector((state) => state.vessel.selectedVessel)
    const { statementDocument, downloadDocument } = useSelector((state) => state.voyage)
    const { user } = useSelector((state) => state.user)
    const [isOrderModalVisible, setOrderModalVisible] = useState(false); 
    const [vesselName, setVesselName] = useState(false); 
    console.log(selectedVessel)
    useEffect(() => {
        if (selectedVessel !== null) {
            
                const tempdata = [
                    {
                        label: "Casper ID",
                        value: selectedVessel?.casper_id,
                    },
                    {
                        label: "IMO Number",
                        value: selectedVessel?.imo_number,
                    },
                    {
                        label: "Vessel Name",
                        value: selectedVessel?.vessel_name,
                    },
                    {
                        label: "WTW",
                        value: `${selectedVessel?.wtw ? selectedVessel?.wtw?.toFixed(3) : '-'} MT` || '-'
                    },
                    {
                        label: "Compliance Balance",
                        value: `${selectedVessel?.cb_current?.toFixed(3)} gCO₂eq`,
                    },
                    {
                        label: "EUA",
                        value: `${selectedVessel?.eua_current?.toFixed(3)}`,
                    },
                    {
                        label: "FEUM Penalty",
                        value: "€" + selectedVessel?.penalty_current?.toFixed(3),
                    },
                    {
                        label: "GHG",
                        value: `${selectedVessel?.ghg_current?.toFixed(3)} gCO₂/MJ`
                    },
                    // {
                    //     label: "Charterer EUA",
                    //     value: temp.charterer_eua,
                    // },
                    
                ]
                setData(tempdata)
        }

       dispatch(getEuaOutstanding({})).then((result) => {
        // console.log(result)
        setSpotPrice(result?.payload?.spot_price)
        })
        if(selectedVessel){

            const temp = {
                ...selectedVessel,
                start_date: "",
                end_date: ""
            }
            dispatch(fetchStatementDocument(temp))
        }
    }, [selectedVessel, dispatch])

    
    const openOrderModal = () => {
        // console.log(selectedVoyage)
        dispatch(fetchPrefilledOrderDetails(selectedVessel)).then((result) => {
            if(result.meta.requestStatus == "fulfilled"){
                setVesselName(selectedVessel?.vessel_name)
                dispatch(fetchHistoryOrderDetails(selectedVessel))
            setOrderModalVisible(true);
            }
        })
    };

    const closeOrderModal = () => {
        setOrderModalVisible(false);
    };

    return (
        <div className='card eua-overview-card'>
            <div className="eua-overview-head">
                <div className="eua-overview-head-title">
                    <span className='card-title-span'>FEUM Overview</span>
                    {/* <Tag color={"#06C270"}>Spot price €{spotPrice}</Tag> */}
                </div>
                {selectedVessel === null ? "" :
                    <div className="eua-overview-head-icons">
                        {/* {user?.role === "admin" && selectedVessel !== null ? 
                            <div onClick={openOrderModal}>
                            <img src={ClipboardText} style={{ height: '20px' }} alt="" />
                            <span className="card-icon-span">Order</span>
                          </div>
                        : ""} */}
                        {/* {downloadDocument !== null ? <DownloadDocument icon={Clipboard} label={"Download"} type={"Download"} /> : <DownloadDocument icon={ClipboardExport} label={"Upload"} type={"Upload"} />} */}
                        {statementDocument === null ? "" : <ReportPdf icon={Report} label={"Report"} doc={EmissionTemplate} />}
                        {user?.role === "admin" && downloadDocument ? <DeleteDocument icon={ClipboardDelete} label={"Delete"} type={"Delete"} /> : ''}
                    </div>}
            </div>
            <div className="eua-overview-details">
                <div className='feum-overview-data'>
                    <Stats data={data} />
                </div>
                
            </div>
            <OrderModal visible={isOrderModalVisible} onClose={closeOrderModal} vesselName={vesselName} spotPrice={spotPrice}/> 
        </div>
    )
}

export default FeumOverview